import { render, staticRenderFns } from "./listinfo.vue?vue&type=template&id=9849aba8&scoped=true"
import script from "./listinfo.vue?vue&type=script&lang=js"
export * from "./listinfo.vue?vue&type=script&lang=js"
import style0 from "./listinfo.vue?vue&type=style&index=0&id=9849aba8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9849aba8",
  null
  
)

export default component.exports